// tslint:disable-next-line:eofline
export * from './fi-item-glcode-link-container.model';
